import { InputBase } from '@material-ui/core';
import React from 'react';

export default function NakedInput(props) {
  return <InputBase {...props} />;
}
